export const getEmailNotificationLabel = (index: number): string => {
  const labels = ['Company Email', '2nd Email', '3rd Email', '4th Email'];

  return labels[index] ?? 'Email';
};
